import { ARTICLE_SLICE_TYPES } from 'dpl/prismic/utils/customPropTypes';
import PullQuote from 'dpl/prismic/article/pull_quote/components/PullQuote';
import Table from 'dpl/prismic/article/table/components/Table';
import Accreditation from 'dpl/common/components/TrustSection';
import CustomLinks from 'dpl/prismic/custom_links/components/CustomLinks';
import MissionCallout from 'dpl/prismic/article/mission_callout/components/MissionCallout';

import Content from '../components/Content';
import SplashPhoto from '../components/SplashPhoto';
import ArticleHeader from '../components/ArticleHeader';
import FeaturedAuthor from '../components/FeaturedAuthor';
import ShareBar from '../components/ShareBar';
import RelatedArticlesList from '../components/RelatedArticlesList';
import NewsletterSignup from '../components/NewsletterSignup';
import Quote from '../components/Quote';
import ActionCallout from '../components/ActionCallout';
import PodcastEmbed from '../components/PodcastEmbed';
import JoinAsBreederCallout from '../components/JoinAsBreederCallout';
import LockedContentModal from '../components/LockedContentModal';

export default {
  [ARTICLE_SLICE_TYPES.BODY_CONTENT]: Content,
  [ARTICLE_SLICE_TYPES.PULL_QUOTE]: PullQuote,
  [ARTICLE_SLICE_TYPES.SPLASH_PHOTO]: SplashPhoto,
  [ARTICLE_SLICE_TYPES.HEADER]: ArticleHeader,
  [ARTICLE_SLICE_TYPES.RELATED_ARTICLES_LIST]: RelatedArticlesList,
  [ARTICLE_SLICE_TYPES.FEATURED_AUTHOR]: FeaturedAuthor,
  [ARTICLE_SLICE_TYPES.SHARE_BAR]: ShareBar,
  [ARTICLE_SLICE_TYPES.NEWSLETTER_SIGNUP]: NewsletterSignup,
  [ARTICLE_SLICE_TYPES.TABLE]: Table,
  [ARTICLE_SLICE_TYPES.QUOTE]: Quote,
  [ARTICLE_SLICE_TYPES.ACCREDITATION]: Accreditation,
  [ARTICLE_SLICE_TYPES.ACTION_CALLOUT]: ActionCallout,
  [ARTICLE_SLICE_TYPES.CUSTOM_LINKS]: CustomLinks,
  [ARTICLE_SLICE_TYPES.PODCAST_EMBED]: PodcastEmbed,
  [ARTICLE_SLICE_TYPES.JOIN_AS_BREEDER_CALLOUT]: JoinAsBreederCallout,
  [ARTICLE_SLICE_TYPES.MISSION_CALLOUT]: MissionCallout,
  [ARTICLE_SLICE_TYPES.LOCKED_CONTENT_MODAL]: LockedContentModal
};
